import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'core-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss']
})
export class SessionExpiredComponent implements OnInit {

  public returnUrl: string = null;
  public rootUrl: string = environment.rootUrl;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['returnUrl']) {
        this.returnUrl = environment.rootUrl + environment.appUrl + params['returnUrl'];
      }
    });
  }

}
